<template>
  <div id="pers-tab6" name="hres31x-tab6" class="content-pers" :class="{'-fixed-height-box' : pcDisp}">
    <template v-for="(value, index) in detail.tableEducation.rows">
      <detail-template
        :index="index"
        :labels="labels"
        :detail="detail"
        inline-template>
        <div>
          <div slot="head" class="sub-topic-box color-skin" @click="toggleDisp()">
            <i class="fa fa-graduation-cap icon-sub-topic" aria-hidden="true"></i>
            <div class="sub-topic">{{ labels['HRES31XC6']['10'] }} {{ index + 1 }}</div>
          </div>

          <div slot="body" class="data-pers-box" v-show="topicDisp">
            <div class="row data-box">
              <div class="col-xs-6 data-label">{{ labels['HRES31XC6']['30'] }}</div>
              <div class="col-xs-6 data-text">{{ value.codedlv }}</div>
            </div>
            <div class="row data-box">
              <div class="col-xs-6 data-label">{{ labels['HRES31XC6']['40'] }}</div>
              <div class="col-xs-6 data-text">{{ value.coddglv }}</div>
            </div>
            <div class="row data-box">
              <div class="col-xs-6 data-label">{{ labels['HRES31XC6']['50'] }}</div>
              <div class="col-xs-6 data-text">{{ value.codmajsb }}</div>
            </div>
            <div class="row data-box">
              <div class="col-xs-6 data-label">{{ labels['HRES31XC6']['60'] }}</div>
              <div class="col-xs-6 data-text">{{ value.codinst }}</div>
            </div>
            <div class="row data-box">
              <div class="col-xs-6 data-label">{{ labels['HRES31XC6']['70'] }}</div>
              <div class="col-xs-6 data-text">{{ value.codcount }}</div>
            </div>
            <div class="row data-box">
              <div class="col-xs-6 data-label">{{ labels['HRES31XC6']['80'] }}</div>
              <div class="col-xs-6 data-text">{{ value.codminsb }}</div>
            </div>
            <div class="row data-box">
              <div class="col-xs-6 data-label">{{ labels['HRES31XC6']['90'] }}</div>
              <div class="col-xs-6 data-text">{{ value.numgpa }}</div>
            </div>
            <div class="row data-box">
              <div class="col-xs-6 data-label">{{ labels['HRES31XC6']['100'] }}</div>
              <div class="col-xs-6 data-text">{{ setYearRangeOutput(value.stayear) }}</div>
            </div>
            <div class="row data-box">
              <div class="col-xs-6 data-label">{{ labels['HRES31XC6']['110'] }}</div>
              <div class="col-xs-6 data-text">{{ value.flgeduc }}</div>
            </div>
          </div>
        </div>
      </detail-template>
    </template>
  </div>
</template>

<script>
import detailTemplate from 'components/hres31x/detailTemplate'

export default {
  name: 'hres31x-tab6',
  components: {
    detailTemplate
  },
  props: [ 'nowLang', 'labels', 'detail', 'pcDisp', 'togglePage', 'triggerButton' ]
}
</script>


// WEBPACK FOOTER //
// tab6.vue?76ba23dd